import React, { useEffect, useState } from "react"

import { getTailwindValue } from "~/utils/tailwind"

export default function HakioIcon({
  color = getTailwindValue("--color-primary-300"),
  hoverColor = "#ffffff",
  width = "22",
  height = "20",
}) {
  const [currentColor, setCurrentColor] = useState(color)

  useEffect(() => {
    setCurrentColor(color)
  }, [color])

  const handleMouseEnter = () => {
    if (hoverColor !== "") {
      setCurrentColor(hoverColor)
    }
  }

  const handleMouseLeave = () => {
    setCurrentColor(color)
  }

  return (
    <svg
      fill="none"
      width={`${width}px`}
      height={`${height}px`}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <path
        d="M16.5905 0.399536V7.74966H5.41113V0.399536H0.962036V19.6004H5.41113V11.8658H16.5905V19.6004H21.038V0.399536H16.5905Z"
        fill={currentColor}
      />
    </svg>
  )
}
